import { cn } from '../../utils';

interface Props {
  children: React.ReactNode;
  addOnClass?: string;
}

/**
 * A functional component that renders a div with a specified class name and children.
 *
 * @param props - The component's props.
 * @param props.children - The content to be rendered inside the div.
 * @param props.addOnClass - An optional class name to be added to the div.
 *
 * @returns - A React element representing the div with the specified class name and children.
 */
export default function ({ children, addOnClass }: Props) {
  return (
    <>
      <div className={cn('text-lg font-semibold text-text-200', addOnClass)}>
        {children}
      </div>
    </>
  );
}
